module.exports = __webpack_public_path__ + "/login_ui/img/tg-23a4a972f00b60e1b47b5c041efca482.svg";